// Core
import React from 'react';
import { Link } from 'react-router-dom';

// Components
import Slider from '../../components/Slider';
import Sliders from '../../components/Sliders';
import CarouselTestimonials from '../../components/CarouselTestimonials';
import CarouselClients from '../../components/CarouselClients';
import GetInTouch from '../../components/GetInTouch';

// Assets
import About from '../../assets/images/homepage/home-about-s.jpeg';
import Vehicle1 from '../../assets/images/vehicle-1.svg';
import Vehicle2 from '../../assets/images/vehicle-2.svg';

// Libraries
import { Container, Col, Row } from 'react-bootstrap';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Marquee from 'react-fast-marquee';

// Data
import { benefits } from '../../Benefits';

const HomepagePrint = () => {
  return (
    <div>
      {/* Hero Slider Sections */}
      <Slider />
      <Sliders />

      {/* About Us Section */}
      <section className="entry pb-unset">
        <Container>
          <Row>
            <Col md={5}>
              <img src={About} alt="About SADP" className="img-fluid my-auto" />
              <div className="info">
                <h4><span>5</span> Years of Experience</h4>
              </div>
            </Col>
            <Col md={7}>
              <h2>About Us</h2>
              <h3>We are your trusted local partner</h3>
              <p>
                We deliver complete building solutions across Te Anau/Manapouri area — safely, reliably, and to a quality standard. We’re a hands-on construction company offering end-to-end delivery — from site preparation through to finished buildings and fit-outs. Whether you’re developing bare land, renovating a shed, or completing a house, we bring the experience and people to get the job done properly.
                <br />
                <br />
                With in-house project management, design, construction, and earthworks teams, we simplify the process and take full responsibility for your project — so you don’t have to manage multiple contractors.
              </p>
              {/* <Link to="/company" className="btn btn-primary">
                Know More <ArrowRightAltIcon />
              </Link> */}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Marquee Vehicle Strip - Left Direction */}
      {/* <Marquee direction="left" className="mt-2" gradientWidth={10}>
        <img src={Vehicle1} alt="Vehicle moving left" />
      </Marquee> */}

      {/* RMC Benefits Section */}
      <section className="section-bg bg-1">
        <Container className="py-md-4">
          <div className="text-center">
            <h2>Why Choose Us</h2>
            <h3 className="type-2">The Benefits of Working with Us</h3>
          </div>
          <Row>
            {benefits.map((benefit, index) => (
              <Col md={6} key={index}>
                <div className="benefits">
                  <img src={benefit.icon} alt={benefit.name} />
                  <h4>{benefit.name}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: benefit.description.substring(0, 105) + '...',
                    }}
                  />
                  {/* <Link to="/services">Read More</Link> */}
                </div>
              </Col>
            ))}
          </Row>
        </Container>

        {/* Marquee Vehicle Strip - Right Direction */}
        {/* <Marquee direction="right" className="mt-2" gradientWidth={10}>
          <img src={Vehicle2} alt="Vehicle moving right" />
        </Marquee> */}
      </section>

      {/* Contact Section */}
      {/* <GetInTouch /> */}

      {/* Client Testimonials Section */}
      {/* <section className="section-bg">
        <Container className="py-2">
          <div className="text-center">
            <h2>Client Testimonials</h2>
            <h3 className="type-2">What People Says About Us</h3>
          </div>
          <CarouselTestimonials />
        </Container>
      </section> */}

      {/* Client Logos Carousel */}
      {/* <section className="section-bg">
        <Container>
          <CarouselClients />
        </Container>
      </section> */}
    </div>
  );
};

export default HomepagePrint;
